module.exports = __webpack_public_path__ + "img/vignette10.66ba82df.jpg";